enum ReportType {
  Employee = 1,
  Employees = 2,
  Projects = 3,
}

export default ReportType

export enum ProjectReportOptions {
  Default = 'DEFAULT',
  ShowHours = 'SHOW_HOURS',
  EmployeeSums = 'EMPLOYEES_SUMS',
  EmployeeSumsWithSubprojects = 'EMPLOYEES_SUMS_WITH_SUBPROJECTS',
}

export const projectsTypeArray: { type: ProjectReportOptions; label: string }[] = [
  {
    type: ProjectReportOptions.Default,
    label: 'page.reports.defaultProjectReport',
  },
  {
    type: ProjectReportOptions.ShowHours,
    label: 'page.reports.includeHoursProjectReport',
  },
  {
    type: ProjectReportOptions.EmployeeSums,
    label: 'page.reports.employeesSums',
  },
  {
    type: ProjectReportOptions.EmployeeSumsWithSubprojects,
    label: 'page.reports.employeesSumsWithSubprojects',
  },
]
